import { createI18n } from 'vue-i18n'
import axios from 'axios'
import { get } from 'lodash'

const loadedLanguages = new Set()
const pendingLoads = new Map() // lang -> Promise

export const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    // You can set these if you want to silence warnings globally:
    // missingWarn: false,
    // fallbackWarn: false,
    messageResolver: (obj, path) => {
        const v = get(obj, path, '')
        return (typeof v === 'string' ? v.replaceAll(/@/g, "{'@'}") : v) || null
    },
})

function getInjectedTranslationsFor(lang) {
    // Recommended shape:
    // window.translations = { language: "bg", translations: {...} }
    const injected = window.translations
    if (!injected) return null

    if (injected.translations && injected.language) {
        return injected.language === lang ? injected.translations : null
    }

    // fallback: if it's a plain object, only apply it to the initially active locale
    if (lang === i18n.global.locale.value) return injected

    return null
}

export async function loadLocale(lang) {
    if (!lang) return

    if (loadedLanguages.has(lang)) return

    if (pendingLoads.has(lang)) return pendingLoads.get(lang)

    const p = (async () => {
        const injected = getInjectedTranslationsFor(lang)
        if (injected) {
            i18n.global.mergeLocaleMessage(lang, injected)
            loadedLanguages.add(lang)
            return
        }

        const { data } = await axios.get(`/api/localization/translation/${lang}`)
        const translations = data?.translations ?? {}
        i18n.global.mergeLocaleMessage(lang, translations)
        loadedLanguages.add(lang)
    })().finally(() => {
        pendingLoads.delete(lang)
    })

    pendingLoads.set(lang, p)
    return p
}

export const setLang = async lang => {
    await loadLocale(lang)

    i18n.global.locale.value = lang

    axios.defaults.headers.common['X-Accept-Language'] = lang
    document.documentElement.setAttribute('lang', lang)
    window.localStorage.setItem('defaultLang', lang)
}